import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as dates from '@simplybenefits/sb-dates';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { Theme, Button, Text } from "@simplybenefits/sb-ui-library";
import { getPendingChangeData } from '../../../actions/accounts.js';
import { styled } from '@mui/system';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main 
}));

class PendingChangesTable extends PureComponent {
    state = {
        selectedChangeID: null,
        changes: null
    };

    _selectChange = async (changeID) => {
        if (this.state.selectedChangeID === changeID) {
            this.setState({
                selectedChangeID: null,
                changes: null
            });

            return;
        }

        const changes = await this.props.dispatch(getPendingChangeData(changeID, this.props.accountID));

        this.setState({
            selectedChangeID: changeID,
            changes
        });
    };

    render() {
        const { records } = this.props;
        const styles = {
            scrollbar: {
                '&::webkitScrollbar': {
                    height: '15px',
                    width: '15px'
                },
                '&::webkitScrollbarThumb': {
                    backgroundColor: Theme.colors.surface,
                    borderRadius: '10px',
                    boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
                },
                '&::webkitScrollbarTrack': {
                    backgroundColor: Theme.colors.backgroundGrey,
                    borderRadius: '10px',
                    boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
                }
            },
            tableHeading: {
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingRight: "2vw",
                paddingLeft: "2vw",
                fontFamily: Theme.fonts.type.heading,
                color: Theme.colors.surface,
                whiteSpace: "nowrap",
                borderBottom: "none"
            },
            tableCell: {
                paddingTop: "10px",
                paddingBottom: "10px",
                fontFamily: Theme.fonts.type.light,
                whiteSpace: "nowrap",
                paddingRight: "2vw",
                paddingLeft: "2vw",
                color: Theme.colors.mainTextGrey
            }
        };

        return (
            <div style={{ overflow: "auto", maxHeight: 600, ...styles.scrollbar }}>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            <TableCell sx={styles.tableHeading}>
                                Type
                            </TableCell>

                            <TableCell sx={styles.tableHeading}>
                                Label
                            </TableCell>

                            <TableCell sx={styles.tableHeading}>
                                Profile Certificate
                            </TableCell>

                            <TableCell sx={styles.tableHeading}>
                                Changed By
                            </TableCell>

                            <TableCell sx={styles.tableHeading}>
                                Processed
                            </TableCell>

                            <TableCell sx={styles.tableHeading}>
                                Effective Date
                            </TableCell>

                            <TableCell sx={styles.tableHeading} />
                        </StyledTableRow>
                    </TableHead>

                    <TableBody>
                        {
                            records.map((item, index) => {
                                let backgroundObject = { border: "none" };
                                if (index % 2 !== 0) {
                                    backgroundObject = { backgroundColor: Theme.colors.backgroundGrey, border: "none" };
                                }

                                return (
                                    <React.Fragment>
                                        <TableRow>
                                            <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                                { item.type }
                                            </TableCell>

                                            <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                                { item.label }
                                            </TableCell>

                                            <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                                { item.profile }
                                            </TableCell>

                                            <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                                { item.changedBy }
                                            </TableCell>

                                            <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                                { dates.getLocalDisplay(item.occurred, 'lll') }
                                            </TableCell>

                                            <TableCell sx={{ ...styles.tableCell, ...backgroundObject }}>
                                                { dates.getUTC(item.effectiveDate, 'll') }
                                            </TableCell>

                                            <TableCell sx={{ ...styles.tableCell, ...backgroundObject, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                                {
                                                    [ 'Member Update', 'Dependent Update', 'Beneficiary Update', 'Mass Salary Uploaded' ].indexOf(item.type) !== -1 &&
                                                        <Button transparent onClick={ () => this._selectChange(item.changeID) }>
                                                            Details
                                                        </Button>
                                                }

                                                <Button transparent onClick={() => this.props.removeChange(item.changeID) }>
                                                    Remove
                                                </Button>
                                            </TableCell>
                                        </TableRow>

                                        {
                                            this.state.selectedChangeID === item.changeID &&
                                                <TableRow>
                                                    <TableCell sx={{ ...styles.tableCell, ...backgroundObject }} colSpan={6}>
                                                        {
                                                            this.state.changes.map((change) => (
                                                                <Text bold margin="5px 0">{ change }</Text>
                                                            ))
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                        }
                                    </React.Fragment>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </div>
        );
    }
}

PendingChangesTable.propTypes = {
    records: PropTypes.array
};

export default (connect()(PendingChangesTable));